import React from 'react'
import { connect } from 'react-redux'
// import _ from 'lodash'
import { fetchSubDiscountOutletsIfNeeded, fetchTaxonomiesIfNeeded} from '~/community/actions'
// import { MapContainer, TileLayer, Popup, Marker, Tooltip } from 'react-leaflet'
// import L from 'leaflet';

if (__CLIENT__) {
  let RL = require('react-leaflet');
  var L = require('leaflet');
  var { MapContainer, TileLayer, Popup, Marker, Tooltip } = RL;
}

console.log(__SERVER__)
console.log(__CLIENT__)
const TaxTypes = (props) => {
  return props.tax.map((x,i) => {
  let id = x.tid
  let taxClass = x.toggle ? "tax true" : "tax false"
    return (
      <span key={id} data-toggle={x.toggle} className={taxClass} onClick={(e) => props.click(id, e)}>{x.name}</span>
    )
  })
}



class SubDiscounts extends React.Component{
  constructor() {
    super()
    this.state = {
      subBands: [],
      commNotices: [],
      subDiscounts: [],
      tax: [],
      benCat: [],
      allToggle: true,
      coords: [],
      showFilters: false,
      zedfun: false
    }
    this.getSize = this.getSize.bind(this)
    this.showOutlet = this.showOutlet.bind(this)
    this.benCat = this.benCat.bind(this)
    this.showFilter = this.showFilter.bind(this)
    this.resizeHandler = this.resizeHandler.bind(this)
    this.outletList = React.createRef();
    this.map = React.createRef();
    this.zedfun = React.createRef();
    this.last = null;
    this.lastMarker = null;
    this.taxes = [];
    this.size = React.createContext([]);
  }
  
  static fetchData(store) {
    return Promise.all([
      store.dispatch(fetchSubDiscountOutletsIfNeeded()),
      store.dispatch(fetchTaxonomiesIfNeeded())
    ])
  }

  componentWillMount(){
    const { dispatch, subDiscountOutlets, taxonomies } = this.props
    dispatch(fetchSubDiscountOutletsIfNeeded())
    dispatch(fetchTaxonomiesIfNeeded())
    if(__CLIENT__){
      window.addEventListener('resize', this.resizeHandler)
      // initial call
      this.resizeHandler();
    }
    this.taxFromListings(subDiscountOutlets, taxonomies)
  }

  resizeHandler() {

    // get window width
    const iw = window.innerWidth;
    const ih = window.innerHeight;
  
    this.size.current = [iw, ih]
    console.log(this.size.current)
  }

  taxFromListings(subDiscountOutlets, taxonomies) {
    if(subDiscountOutlets.items.length > 1 && taxonomies.items.length > 1) {
      let tax = subDiscountOutlets.items.map(i => i['taxonomy_vocabulary_1'])
      // let tax = _.map(subDiscountOutlets.items, 'taxonomy_vocabulary_1')
      let tax2 = tax.flat().filter((item, pos, self) => self.findIndex(v => v.target_id === item.target_id) === pos);
      // let tax2 = _.uniqBy(_.flatten(tax), 'target_id')
     
      tax = [ ...new Set(tax.flat().map(i => i['target_id'])) ]
      // tax = _.uniq(_.map(_.flatten(tax), 'target_id'))
      this.taxes = taxonomies.items.filter( a => tax2.find( b => b.target_id === a.tid[0].value))
      // this.taxes = _.filter(taxonomies.items, function(a){
      //   return _.find(tax2, function(b){
      //       return b.target_id === a.tid[0].value;
      //   })
      // })
      this.taxes = this.taxes.map( i => ({ tid: i.tid[0].value, name: i.name[0].value, toggle: true }) )
      // this.taxes = _.map(this.taxes, function(i) { return { tid: i.tid[0].value, name: i.name[0].value, toggle: true } })
      let coords = subDiscountOutlets.items.map( (i, n) => i.coordinates.length  > 0 ? { title: i.title[0].value, index: n, coordinates: i.coordinates[0].value } : null ).filter( i => i) 

      this.setState({ benCat: this.taxes, coords: coords })
    }
  }
  componentWillReceiveProps(nextProps){
    const { subDiscountOutlets, communityNotices, subBands, taxonomies, match } = nextProps

    this.taxFromListings(subDiscountOutlets, taxonomies)
    
  }

  componentWillUnmount() {
    if(__CLIENT__)
      window.removeEventListener('resize', this.resizeHandler)
  }

  getSize() {
    console.log(this.size.current)
    return this.size.current
  }
  showOutlet(ev, index){
    const [ w, h ] = this.size.current;
    console.log(w,h)
    if (this.last) {
      this.last.style.display = 'none'
    }
    if (this.lastMarker) {
      this.lastMarker.closeTooltip();
    }
    let item = this.props.subDiscountOutlets.items[index];
    let coords = item.coordinates.length > 0 ? item.coordinates[0].value : null;
    if (coords) {
      const map = this.map.current
      const [lat, lng] = coords.split(',') 

      // console.log(map.getPixelOrigin())
      // let point = map.latLngToContainerPoint([lat, lng]);
      // let newPoint = L.point([point.x + 11, point.y]);
      // let newLatLng = map.containerPointToLatLng(newPoint);

      // map.setView([lat, lng], 15, { animate: false,  paddingTopLeft: [0, 0],
      //   paddingBottomRight: [300, 0]})

      console.log(coords)
      let marker = null; 
      map.eachLayer(layer => { if(layer instanceof L.Marker) { if(layer.getLatLng().lat == lat && layer.getLatLng().lng == lng) { marker = layer } } })

      // let marker = Object.values(map._layers).find(i =>  i._latlng?.lat == lat && i._latlng?.lng == lng )
      console.log(marker)
      let icon = marker.getIcon()
      icon.options.iconSize = [50, 50]
      marker.setIcon(icon)
      setTimeout( () => { icon.options.iconSize = [30, 30]; marker.setIcon(icon) }, 1000)
      marker.update()
      // map.openTooltip(marker._tooltip, marker.getLatLng()) 
      marker.openTooltip();
      let features = [];
      map.eachLayer( function(layer) {
        if(layer instanceof L.Marker) {
          if(map.getBounds().contains(layer.getLatLng())) {
            features.push(layer);
          }
        }
      });
      console.log(features);
      
      var center = L.latLng(lat, lng);
      var bounds = center.toBounds(3000);
      let paddingTL = [0, 0];
      let paddingBR = [0, 0];
      if (w < 640)
        paddingBR = [0, 350]
      else 
        paddingBR = [350, 0];
      
    
      console.log(this.size.current, w, paddingBR)
      setTimeout(() => { 
        this.map.current.fitBounds(bounds,  {
          animate: true,
          paddingTopLeft: paddingTL,
          paddingBottomRight: paddingBR
        }) } , 0);

      this.lastMarker = marker;
      // setTimeout(() => { 
      //   let offset = map.getSize().x*0.1;
      //   map.panBy(new L.Point(offset, 0), {animate: false});
      // }, 250)

    }
    else {
      console.log('no coords')
    }
    
    const listing = this.outletList.current.querySelector("[data-idx='" + index +"']")
    listing.lastChild.style.display = 'block'
    // ev.currentTarget.nextSibling.style.display = 'block'
    // this.last = ev.currentTarget.nextSibling
    this.last = listing.lastChild
    listing.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
    // window.scrollTo(0, ev.currentTarget.offsetTop)
  }

  showFilter() {
    this.setState( prevState => ({ showFilters: !prevState.showFilters }))
    this.benCat('toggle')
  }

  benCat(id, e){
    if (id === 'all') {
      this.setState( prevState => {
        let arr = prevState.benCat.map(item => ({...item, toggle: true }))
        return { showFilters: false, allToggle: true, benCat: arr }
      })
    }
    else if (id === 'toggle') {
      this.setState( prevState => {
        let arr = prevState.benCat.map(item => ({...item, toggle: !prevState.allToggle }))
        return { filterallToggle: !prevState.allToggle, benCat: arr }
      })
    }
    else {

      this.setState(prevState => {
        let arr = prevState.benCat
        function toggle(arr, item) {
          var idx = arr.findIndex( a => a['tid'] === id )
          // var idx = _.findIndex(arr, ['tid', id]);
          arr[idx]['toggle'] = !arr[idx]['toggle']
        }

        toggle(arr, id)
        return {
          benCat: arr
        }
      })
    }
  }

  render() {
    const { subDiscountOutlets, taxonomies, match } = this.props
    let allTog = this.state.allToggle ? "tax true" : "tax false"
    let allTogText = this.state.allToggle ? "NONE" : "ALL"

    // let taxTypes = this.state.benCat.map((x,i) => {
    //   let id = x.tid
    //   let taxClass = x.toggle ? "tax true" : "tax false"
    //   return (
    //     <span key={id} data-toggle={x.toggle} className={taxClass} onClick={(e) => this.benCat(id, e)}>{x.name}</span>
    //   )
    // })

    var benCat = this.state.benCat

    let cats = benCat.filter(i => i.toggle).map(i => i.tid);
    let subOut = subDiscountOutlets.items.map((i,n) => ({ ...i, index: n })).filter(i => { return i.taxonomy_vocabulary_1.length } ).filter(i => Array.isArray(i.taxonomy_vocabulary_1) && i.taxonomy_vocabulary_1.some(i => cats.includes(i.target_id) )) 
    
    // let subOut = subDiscountOutlets.items.map((i,n) => ({ ...i, index: n })).filter( a => { if (a.taxonomy_vocabulary_1 && a.taxonomy_vocabulary_1[0] && a.taxonomy_vocabulary_1[0].target_id ) { return benCat.find( b => b.tid === a.taxonomy_vocabulary_1[0].target_id && b.toggle) } });
    // let subOut = _.filter(subDiscountOutlets.items, function(a){
    //   if (a.taxonomy_vocabulary_1 && a.taxonomy_vocabulary_1[0] && a.taxonomy_vocabulary_1[0].target_id ) {
    //     return _.find(benCat, function(b){
    //       return b.tid === a.taxonomy_vocabulary_1[0].target_id && b.toggle
    //     })
    //   }

    // })
    let formatAddress = (loc) => (
      <div className="address">
        {loc.organization} <br/>
        {loc.address_line1} <br/>
        {loc.address_line2 ? <span>{loc.address_line2} <br/></span> : null}
        {loc.locality} <br/>
        {loc.administrative_area} {loc.postal_code} <br/>
      </div>
     )
     let subOutlets = subOut.map((x, i) =>
       <div key={i} data-idx={x.index} style={{borderBottom: '1px solid white'}} className={ x.field_directory_type[0].value }>
        <div className="directory-name" onClick={ e => this.showOutlet(e, x.index)}>{ x.title[0].value }{ x.coordinates.length > 0 && x.coordinates[0].value ? null : <span style={{float: 'right'}}>web</span> }</div>
        {/* <div onClick={ e => this.showOutlet(e, x.index)}>{ x.title[0].value } <span className={ 'button ' + x.field_directory_type[0].value }>{ x.field_directory_type[0].value }</span></div> */}
        <div className="description" style={{display: 'none'}}>
           <div className="sections">
            <div className="directory-logo">
              { x.field_directory_logo.length ? <img src={ x.field_directory_logo[0].url } style={{width: '100%', height: 'auto'}}/> : null }
            </div>
             <div className="directory-info" style={{padding: '1em'}}>
               <h2>{ x.title[0].value }</h2>
               <div>{ x.field_directory_discount.length ? <em>{x.field_directory_discount[0].value}</em> : null }</div>
               <div dangerouslySetInnerHTML={{ __html: x.body[0].value }} />
               { x.field_directory_location.length ? formatAddress(x.field_directory_location[0]) : null }
               { x.field_directory_link.length ? <a href={x.field_directory_link[0].uri} target='_blank'>{x.field_directory_link[0].uri}</a> : null}
             </div>
           </div>
         </div>
       </div>
     )
     const position = [-27.45685, 153.03115]

     var outletIcon, zedIcon
     if(__CLIENT__){
        outletIcon = new L.Icon({
          iconUrl: '/assets/heart.svg',
            iconRetinaUrl: '/assets/heart.svg',
            popupAnchor:  [-0, -10],
            iconSize: [30, 30],
            className: 'zed-heart-icon'
        });

        zedIcon = new L.Icon({
          iconUrl: '/assets/4zzz.svg',
            iconRetinaUrl: '/assets/4zzz.svg',
            popupAnchor:  [-0, -10],
            iconSize: [30, 30],
            className: 'zed-heart-icon'
        });
      }
     return (
       <div id="supporters"><div>
        { __CLIENT__ && <MapContainer id="supporters-map" ref={this.map} zoomControl={true} style={{}} center={position} zoom={11} zoomSnap={0.5} scrollWheelZoom={true} whenReady={
               (e) => {
                console.log('loaded')
                const map = e.target;
                const [ w, h ] = this.size.current;
                let offsetX = 0;
                let offsetY = 0;
                if (w < 640)
                  offsetY = map.getSize().y*0.25;
                else 
                  offsetX = map.getSize().x*0.15;

                map.panBy(new L.Point(offsetX, offsetY), {animate: false});
              }} >
          <TileLayer
            attribution='Map tiles by <a href="http://stamen.com">Stamen Design</a>.'
            url="https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png"
          />

          <React.Fragment>{
          this.state.coords.map( (c, x) => 
          <Marker key={x}
            eventHandlers={{
              click: (e) => {
                console.log('marker clicked', c.index)
                if(this.state.showFilters)
                  this.benCat('all')
                this.showOutlet(e, c.index)
              },
            }} 
            position={c.coordinates.split(',')} icon={outletIcon}>
            <Tooltip direction="top" offset={[0, -20]} >
              {c.title}
            </Tooltip>
          </Marker>
          )}
          </React.Fragment>
          <Marker key={'4zzz'}
            eventHandlers={{
              click: (e) => {

                console.log('4ZZZ is the beez neez')
                this.setState({zedfun: true});
                setTimeout(() => { this.setState({zedfun: false}); }, 10000 )

              },
            }} 
            position={position} icon={zedIcon}>
            <Tooltip direction="top" offset={[0, -20]} >
              Radio 4ZZZ
            </Tooltip>
          </Marker>
        </MapContainer>}</div>
        { this.state.zedfun && <div className="zed-fun"></div>}
        <div ref={this.outletList} id="outlet-list" style={{}}>
          { this.state.zedfun ? 
          <div>
            <img src="/assets/barry.jpg" style={{width: '100%', height: 'auto'}}/>
            <h2 style={{fontSize: '16pt', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center'}}>All hail the mighty Barry in all it's Beastman glory!</h2>
          </div> : 
          <div>
          <h1>Sub Discounters</h1>
          <div className="filter-button" onClick={this.showFilter}>Fiter by category</div>
          { this.state.showFilters && <div className='filters'>
            <span key='all' style={{fontWeight: 'bold'}} className={allTog} onClick={(e) => this.benCat('toggle', e)}>{allTogText}</span>
            <TaxTypes tax={this.state.benCat} click={this.benCat}></TaxTypes>
            </div>
          }

          {subOutlets}
        </div> }
        </div> 
       </div>
     )
  }
}
export default connect(state => ( { subDiscountOutlets: state.subDiscountOutlets, taxonomies: state.taxonomies })) (SubDiscounts)
